import {
  TGetClusterPopupForMapResponse,
  IGetClusterPopupForMapResponse200,
} from '../../../../../../../../repositories/search-engine/v1/get-cluster-popup-for-map';

import { ResponseError } from '../../../../../../../../errors/ResponseError';

export function assertUnknownError(
  response: TGetClusterPopupForMapResponse,
): asserts response is IGetClusterPopupForMapResponse200 {
  if (response.statusCode !== 400) {
    return;
  }

  const { message, errors } = response.response;

  const mergedMessage = `${message}${errors &&
    typeof errors === 'object' &&
    ` (${errors.map(e => e.message).join('; ')})`}`;

  throw new ResponseError({
    domain: 'PopupManager/services/getClusterPopup/assert#assertUnknownError()',
    message: mergedMessage,
    details: {
      errors,
    },
  });
}
